import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextInput, Typography } from '@guildeducationinc/recess';
import { useClientProgramLevels } from '@src/hooks/useClientProgramLevels';
import { MuiMultiSelect, useLocale } from 'pe-core-frontend';
import { useMemo } from 'react';
export const ProgramPolicy = ({ clientId, policy, onChange, readonly, }) => {
    const { t } = useLocale();
    const { clientProgramLevels } = useClientProgramLevels({
        clientId,
        isActive: true,
        // Use a large page size to ensure all active program levels are loaded for this dropdown.
        // If clients ever exceed this, consider implementing proper pagination in useClientProgramLevels.
        initialPageSize: 10000,
    });
    const programLevelOptions = useMemo(() => {
        return (clientProgramLevels || []).map((cpl) => ({
            value: cpl.programLevelId.toString(),
            label: cpl.programLevel?.name ?? t('N/A'),
        }));
    }, [clientProgramLevels]);
    const handleOnChange = (event) => {
        onChange({
            ...policy,
            programLevels: event.selection?.map(x => x.value) ?? undefined,
        });
    };
    return (_jsxs("div", { className: 'flex flex-col gap-2', children: [_jsx(MuiMultiSelect, { disabled: readonly, label: t('Allowed Program Levels'), onChange: handleOnChange, options: programLevelOptions, value: policy.programLevels ?? [] }), _jsxs("fieldset", { children: [_jsx("legend", { children: _jsx(Typography, { variant: 'label1', children: t('Single expense date') }) }), _jsxs("div", { className: 'flex flex-col gap-2 ml-8', children: [_jsx(TextInput, { label: t('Label'), value: policy.singleExpenseDate?.label || '', onChange: e => onChange({
                                    ...policy,
                                    singleExpenseDate: {
                                        ...(policy.singleExpenseDate || {}),
                                        label: e.currentTarget.value,
                                    },
                                }), disabled: readonly }), _jsx(TextInput, { label: t('Description'), value: policy.singleExpenseDate?.description || '', onChange: e => onChange({
                                    ...policy,
                                    singleExpenseDate: {
                                        ...(policy.singleExpenseDate || {}),
                                        description: e.currentTarget.value,
                                    },
                                }), disabled: readonly }), _jsx(TextInput, { label: t('Tooltip'), value: policy.singleExpenseDate?.tooltip || '', onChange: e => onChange({
                                    ...policy,
                                    singleExpenseDate: {
                                        ...(policy.singleExpenseDate || {}),
                                        tooltip: e.currentTarget.value,
                                    },
                                }), disabled: readonly })] })] })] }));
};
